@if (templateWidgetComponent$ | async; as templateWidgetComponent) {
    <ng-container [ngComponentOutlet]="templateWidgetComponent" [ngComponentOutletInputs]="{ config: templateWidgetComponentConfig }" />
}
